export default __webpack_public_path__ + "static/media/wave.ed9d8111.svg";